import { PayloadAction, createSlice } from '@reduxjs/toolkit';
import { EntityTypes } from 'constants/entities';
import { newSigninRequest } from 'core/services/authentication';

export interface IModal {
  id?: number;
  type: Modals;
  entityType?: EntityTypes;
  message?: string;
  data?: any;
}

export enum Modals {
  DELETE = -1,
  LAUNCH = 0,
  ADD_COURSE_USERS = 1,
  ADD_USERS = 2,
  ADD_MODULE = 3,
  ADD_CAMPAIGN = 4,
  ADD_ACTION = 5,
  ERROR = 6,
  TIMER = 7,
  ACTION_VARIABLE = 8,
  RESET = 9,
  EDIT_ACTION = 10,
  EDIT_TRANSCRIPTION = 11,
  DELETE_COURSE_USERS = 12,
  ADD_COURSE_ADMIN = 13,
  MODULE_VERSION = 14,
  PAUSE_CAMPAIGN = 15,
  ADD_VARIABLE = 16,
  MODULE_VARIABLE = 17,
  HELP = 18,
  ADD_RESOURCE = 18,
  SHARE_MODULE = 19,
  MODULE_ASSESS = 20,
  EDIT_TEXT = 21,
  ADD_SYSTEM = 22,
  ADD_GROUP = 23,
  ADD_CERTIFICATE = 24,
  ACTION_MEDIA = 25,
  EDIT_ORG_SYSTEM = 26,
  ACTION_VOICE_MEDIA = 27,
}

const initialState: IModal = { id: null, type: null };

export const modalsSlice = createSlice({
  name: 'modals',
  initialState,
  reducers: {
    setModal: (state, action: PayloadAction<IModal>) => action.payload,
    clearModal: state => (state = initialState),
  },
  extraReducers: builder => {
    builder.addCase(newSigninRequest.fulfilled, (state, action) => {
      state = {
        type: Modals.HELP,
        id: null,
      };
    });
  },
});

export const { setModal, clearModal } = modalsSlice.actions;

export default modalsSlice.reducer;
